module.exports = __webpack_public_path__ + "img/Recurso 4@300x.6185e750.webp";